(function() {

	'use strict';

	window.TimeoutRunner = TimeoutRunner;

	function TimeoutRunner( fn, timeout_ms, opts ) {
		this.$$timeout   = null;

		this.$$stime_ms  = null; // Viimeisimmän käynnistyksen aika

		this.$$paused_ms = null; // Pausetuksen ajankohta 

		this.$$offset_ms = 0;    // Viimeisimmän käynnistyksen offset (aiempi offset + pausetuksen ajankohdan ja alkuajjankohdan erotus)

		Object.defineProperty( this, "play_ms", {
			get: function() {
				if (this.$$paused_ms) {
					return this.$$offset_ms;
				} else {
					return this.$$offset_ms + (Date.now() - this.$$stime_ms);
				}
			}
		});

		this.timeout_fn = fn;
		this.timeout_ms = timeout_ms;
		this.opts       = opts || {};

		if (!this.opts.watcher_freq_ms) this.opts.watcher_fn = null;
		else if (this.opts.watcher_fn)  this.opts.watcher_fn = this.opts.watcher_fn.bind( this );

		this.$$watcher = null;

		this.start();
	}

	TimeoutRunner.prototype.start = function startFn() {
		if (this.$$timeout != null) this.stop();

		this.$$stime_ms = Date.now();

		this.$$timeout  = setTimeout( this.timeout_fn, this.timeout_ms - this.$$offset_ms );

		if (this.opts.watcher_fn) {
			this.$$watcher = setInterval( this.opts.watcher_fn, this.opts.watcher_freq_ms );
		}

		this.opts.onStart && this.opts.onStart.call( this );
	};

	TimeoutRunner.prototype.stop = function stopFn() {
		clearTimeout( this.$$timeout );
		this.$$timeout = null;

		clearInterval( this.$$watcher );
		this.$$watcher = null;

		this.opts.onStop && this.opts.onStop.call( this );
	};


	TimeoutRunner.prototype.pause = function pauseFn() {
		if (this.$$paused_ms != null) return;

		this.$$paused_ms = Date.now();
		this.$$offset_ms += this.$$paused_ms - this.$$stime_ms;

		this.stop();

		this.opts.onPause && this.opts.onPause.call( this );
	};

	TimeoutRunner.prototype.unpause = function unpauseFn() {
		if (this.$$paused_ms == null) return;
		
		this.start();
		this.$$paused_ms = null;

		this.opts.onUnpause && this.opts.onUnpause.call( this );
	};
})();
